import React from 'react';

function Footer(props) {
  return (
    <footer>
      <p className='footerP'>Made by Kevin Bugusky</p>
    </footer>
  );
}

export default Footer;
